import {
  BedDoubleIcon,
  Building2Icon,
  HomeIcon as DefaultIcon,
  HomeIcon,
  HotelIcon,
  KeyIcon,
  TentIcon,
} from 'lucide-react';

import {
  ACCOMMODATION_CONFIG,
  ACCOMMODATION_KEYWORDS,
  VALID_ACCOMMODATION_SUBCATEGORIES,
  detectAccommodationSubcategory,
  detectAccommodationSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  ACCOMMODATION_CONFIG,
  ACCOMMODATION_KEYWORDS,
  VALID_ACCOMMODATION_SUBCATEGORIES,
  detectAccommodationSubcategory,
  detectAccommodationSubcategoryWithConfidence,
};

type AccommodationIcon = React.ComponentType<{ className?: string }>;

export const ACCOMMODATION_SUBCATEGORY_ICONS: Record<
  string,
  AccommodationIcon
> = {
  hotel: HotelIcon,
  airbnb: HomeIcon,
  apartment: Building2Icon,
  house: HomeIcon,
  rent: KeyIcon,
  hostel: BedDoubleIcon,
  camping: TentIcon,
  default: DefaultIcon,
};

export function getAccommodationIcon(
  subcategory: string | null | undefined
): AccommodationIcon {
  if (!subcategory || !(subcategory in ACCOMMODATION_SUBCATEGORY_ICONS)) {
    return ACCOMMODATION_SUBCATEGORY_ICONS.default;
  }
  return ACCOMMODATION_SUBCATEGORY_ICONS[subcategory];
}
